export const manifest = {
  screens: {
    scr_slxm3o: { name: "Admin Dashboard", route: "/", position: {"x":160,"y":3800} },
    scr_hh16nc: { name: "Storefront", route: "/", state: {"activeTab":"storefront"}, position: {"x":160,"y":5780} },
    scr_onkp5s: { name: "ROI Landing Page", route: "/", state: {"activeTab":"roi"}, position: {"x":160,"y":1820} },
    scr_6xonoa: { name: "ROI App Login", route: "/", state: {"activeTab":"roi-app","view":"login"}, position: {"x":1560,"y":1820} },
    scr_z2wrv5: { name: "ROI App Registration", route: "/", state: {"activeTab":"roi-app","view":"register"}, position: {"x":4360,"y":1820} },
    scr_63pak6: { name: "ROI App Dashboard (KPIs)", route: "/", state: {"activeTab":"roi-app","view":"dashboard","activePage":"dashboard"}, position: {"x":2960,"y":1820} },
    scr_71ye3j: { name: "ROI App Daily Ops", route: "/", state: {"activeTab":"roi-app","view":"dashboard","activePage":"daily-ops"}, position: {"x":5760,"y":1820} },
    scr_aatmpf: { name: "ROI App Inventory", route: "/", state: {"activeTab":"roi-app","view":"dashboard","activePage":"inventory"}, position: {"x":7160,"y":1820} },
    scr_zrvy4j: { name: "ROI App Add Invoice Modal", route: "/", state: {"activeTab":"roi-app","view":"dashboard","activePage":"inventory","showInvoiceModal":true}, position: {"x":21160,"y":1820} },
    scr_ck4l94: { name: "ROI App P&L Recap", route: "/", state: {"activeTab":"roi-app","view":"dashboard","activePage":"pnl"}, position: {"x":8560,"y":1820} },
    scr_k4rt73: { name: "ROI App Food Cost", route: "/", state: {"activeTab":"roi-app","view":"dashboard","activePage":"food-cost"}, position: {"x":16960,"y":1820} },
    scr_l7oa9w: { name: "ROI App Payroll", route: "/", state: {"activeTab":"roi-app","view":"dashboard","activePage":"payroll"}, position: {"x":18360,"y":1820} },
    scr_16kgg1: { name: "ROI App Vendors", route: "/", state: {"activeTab":"roi-app","view":"dashboard","activePage":"vendors"}, position: {"x":9960,"y":1820} },
    scr_l2k45e: { name: "ROI App Add Vendor Modal", route: "/", state: {"activeTab":"roi-app","view":"dashboard","activePage":"vendors","showAddModal":true}, position: {"x":19760,"y":1820} },
    scr_7fyjgd: { name: "ROI App Reports", route: "/", state: {"activeTab":"roi-app","view":"dashboard","activePage":"reports"}, position: {"x":11360,"y":1820} },
    scr_aytrf5: { name: "ROI App Inventory Mgmt", route: "/", state: {"activeTab":"roi-app","view":"dashboard","activePage":"inventory-mgmt"}, position: {"x":12760,"y":1820} },
    scr_jfr6me: { name: "ROI App External Links", route: "/", state: {"activeTab":"roi-app","view":"dashboard","activePage":"external-links"}, position: {"x":14160,"y":1820} },
    scr_obm6yh: { name: "ROI App Gallery", route: "/", state: {"activeTab":"roi-app","view":"dashboard","activePage":"gallery"}, position: {"x":15560,"y":1820} },
  },
  sections: {
    sec_6zm85f: { name: "ROI App Flow", x: 0, y: 1600, width: 22520, height: 1180 },
    sec_tky478: { name: "Admin Dashboard", x: 0, y: 3580, width: 1520, height: 1180 },
    sec_lug7a5: { name: "Storefront", x: 0, y: 5560, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_6zm85f", children: [
      { kind: "screen", id: "scr_onkp5s" },
      { kind: "screen", id: "scr_6xonoa" },
      { kind: "screen", id: "scr_63pak6" },
      { kind: "screen", id: "scr_z2wrv5" },
      { kind: "screen", id: "scr_71ye3j" },
      { kind: "screen", id: "scr_aatmpf" },
      { kind: "screen", id: "scr_ck4l94" },
      { kind: "screen", id: "scr_16kgg1" },
      { kind: "screen", id: "scr_7fyjgd" },
      { kind: "screen", id: "scr_aytrf5" },
      { kind: "screen", id: "scr_jfr6me" },
      { kind: "screen", id: "scr_obm6yh" },
      { kind: "screen", id: "scr_k4rt73" },
      { kind: "screen", id: "scr_l7oa9w" },
      { kind: "screen", id: "scr_l2k45e" },
      { kind: "screen", id: "scr_zrvy4j" },
    ] },
    { kind: "section", id: "sec_tky478", children: [
      { kind: "screen", id: "scr_slxm3o" },
    ] },
    { kind: "section", id: "sec_lug7a5", children: [
      { kind: "screen", id: "scr_hh16nc" },
    ] },
  ],
}
